import React from "react";
import { css } from "emotion";
import { colors } from "../../styles/theme";

const ProgressBar = ({percentage}) => {

  return (
    <div className={container}>
      <div className="progress-outer">
        <div className="progress-inner" style={{width: `${percentage}%`,}}/>
      </div>
    </div>
  );
};

export default ProgressBar;

const container = css`
  .progress-outer {
    background-color: ${colors.inputBackground};
    border-radius: 50px;
    height: 30px;
    width: 100%;
    overflow: hidden;
    
    .progress-inner {
      background-color: ${colors.premiumPlan};
      height: 100%;
      max-width: 100%;
    }
  }
`;
